require('./bootstrap-setup');
import AOS from 'aos';
import CookieNotification from 'bb-cookie-notification';
import axios from 'axios';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import Flickity from 'flickity-imagesloaded';
import ModuloBox from './plugins/modulobox.js';
import './plugins/gridzy.min.js';

import * as FilePond from "filepond";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';

new CookieNotification();

AOS.init();

if(document.querySelector('[data-show-target]')) {
    document.querySelectorAll('[data-show-target]').forEach((element) => {
        if(document.querySelector(element.dataset.showTarget)) {
            const changeFunction = (element) => {
                if(element.dataset.showTargetValue === document.querySelector(element.dataset.showTarget + ':checked').value) {
                    element.classList.remove('d-none');
                } else {
                    element.classList.add('d-none');
                }
            }

            document.querySelectorAll(element.dataset.showTarget).forEach((el) => {
                el.addEventListener('change', () => {
                    changeFunction(element);
                });
            });

            changeFunction(element);
        }
    });
}


// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

if(document.querySelector('.files')) {
    FilePond.registerPlugin(FilePondPluginFileValidateType);
    FilePond.registerPlugin(FilePondPluginFileEncode);
    const filepond = FilePond.create(document.querySelector('.files'), {
        allowMultiple:                         true,
        instantUpload:                         false,
        required:                              true,
        acceptedFileTypes:                     ['image/png', 'image/jpeg', 'image/jpg', 'application/postscript'],
        fileValidateTypeLabelExpectedTypesMap: {
            'image/png':              '.png',
            'image/jpeg':             '.jpeg',
            'image/jpg':              '.jpg',
            'application/postscript': '.eps'
        },
        labelFileTypeNotAllowed:               'Onjuist bestandstype!',
        fileValidateTypeLabelExpectedTypes:    'Alleen {allButLastType} en {lastType} zijn togestaan',
        labelIdle:                             'Sleep je bestanden hiernaartoe of <span class="filepond--label-action"> blader </span>'
    });
}
const submitForm = (gRecaptchaResponse) => {
    const form = document.getElementById('form');

    const submitButton = form.querySelector('[type="submit"]');
    submitButton.classList.add('disabled');
    submitButton.disabled  = true;
    submitButton.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Laden...</span></div>';

    const formData = new FormData(form);
    formData.append('g-recaptcha-response', gRecaptchaResponse);

    const validationAlert = document.getElementById('form-validation');
    validationAlert.classList.add('hidden');
    validationAlert.classList.remove('alert-danger');

    document.querySelectorAll('.invalid-feedback').forEach((element) => {
        if(!element.classList.contains('d-none')) {
            element.classList.add('d-none');
        }
    });

    document.querySelectorAll('.is-invalid').forEach((element) => {
        element.classList.remove('is-invalid');
    });

    axios.post(form.action, formData).then((response) => {
        if(response.data.success) {
            validationAlert.innerHTML = response.data.message;
            validationAlert.classList.add('alert-success');
            validationAlert.classList.remove('d-none');

            form.innerHTML = '';
        }
    }).catch((exception) => {
        if(exception.response.data.errors) {
            for(let error in exception.response.data.errors) {
                const el = form.querySelector('[id="' + error + '"]');
                if(el) {
                    el.classList.add('is-invalid');
                    if(el.parentNode.querySelector('.d-none') !== null) {
                        el.parentNode.querySelector('.d-none').classList.remove('d-none');
                    }
                }
            }
        }
    }).finally(() => {
        submitButton.classList.remove('disabled');
        submitButton.disabled  = false;
        submitButton.innerHTML = '<span>Meld je aan!</span>';
    });
}

window.submitForm = submitForm;

// Add and remove class on scroll
if(document.querySelector('nav')) {
    let scrollpos      = window.scrollY
    const header       = document.querySelector("nav")
    const headerHeight = header.offsetHeight

    const addClassOnScroll    = () => header.classList.add("navbar-shrink")
    const removeClassOnScroll = () => header.classList.remove("navbar-shrink")

    window.addEventListener('scroll', function() {
        scrollpos = window.scrollY;

        if(scrollpos >= headerHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }
    });
}

// Smooth scroll
if(document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const href      = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top:      offsetTop,
                behavior: "smooth"
            });
        });
    });
}

// Parallax
if(document.querySelector('#parallax')) {
    const elem     = document.querySelector("#parallax");
    const parallax = (e) => {
        let _w                        = window.innerWidth / 1;
        let _h                        = window.innerHeight / 1;
        let _mouseX                   = e.clientX;
        let _mouseY                   = e.clientY;
        let _depth                    = `${50 - (_mouseX - _w) * 0.01}% ${50 - (_mouseY - _h) * 0.01}%`;
        elem.style.backgroundPosition = `${_depth}`;
    }

    document.addEventListener("mousemove", parallax);
}

if(document.getElementById('map')) {
    // Google maps

    const locations = JSON.parse(document.getElementById('map').dataset.locations);

    const map = new google.maps.Map(document.getElementById('map'), {
        zoom:      7,
        center:    new google.maps.LatLng(52.155140, 5.387217),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles:    [{
            featureType: 'transit',
            elementType: 'labels.icon',
            stylers:     [{
                visibility: 'off'
            }]
        }, {
            featureType: 'poi',
            stylers:     [{
                visibility: 'off'
            }]
        },]
    });

    const infowindow = new google.maps.InfoWindow();
    const bounds     = new google.maps.LatLngBounds();

    let marker, i;

    const icon = {
        url:        "/img/marker.png", // url
        scaledSize: new google.maps.Size(30, 45), // scaled size
    };

    for(let i in locations) {
        marker = new google.maps.Marker({
            map:      map,
            icon:     icon,
            position: new google.maps.LatLng(parseFloat(locations[i][0]['latitude']), parseFloat(locations[i][0]['longitude'])),
        });

        bounds.extend({
            lng: parseFloat(locations[i][0]['longitude']),
            lat: parseFloat(locations[i][0]['latitude'])
        })
        google.maps.event.addListener(marker, 'click', (function(marker, i) {
            return function() {
                let content = '';
                for(let key in locations[i]) {
                    if(parseInt(key) === 0) {
                        content += `<h5><a href="${locations[i][key]['url']}">${locations[i][key]['title']}</a></h5>`;
                    } else {
                        if(parseInt(key) === 1) {
                            content += `<ul style="padding-left:1rem;">`
                        }
                        content += `<li><a href="${locations[i][key]['url']}">${locations[i][key]['title']}</a></li>`;
                        if(parseInt(key) === locations[i].length - 1) {
                            content += `</ul>`
                        }
                    }
                }
                infowindow.setContent(content);
                infowindow.open(map, marker);
            }
        })(marker, i));
    }
    map.fitBounds(bounds);
}

// Masonry

// init Masonry
if(document.querySelector('.grid')) {
    let grid                      = document.querySelector('.grid');
    const worldOfTechniqueMasonry = new Masonry(grid, {
        itemSelector:    '.grid-item',
        columnWidth:     '.grid-sizer',
        percentPosition: true,
        gutter:          '.gutter-sizer'
    });

    imagesLoaded(grid).on('progress', function() {
        // layout Masonry after each image loads
        worldOfTechniqueMasonry.layout();
    });

}

// Init Flickity
if(document.querySelector('.main-carousel')) {
    let elem  = document.querySelector('.main-carousel');
    let flkty = new Flickity(elem, {
        // options
        cellAlign:    'left',
        autoPlay:     1500,
        pageDots:     false,
        wrapAround:   true,
        contain:      true,
        imagesLoaded: true
    });
}

// Modulobox
var modulobox = new ModuloBox({
    mediaSelector:      '.gallery figure > a, .hidden-gallery div',
    loop:               3,
    history:            true,
    controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
    shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
    videoMaxWidth:      1440,
    minZoom:            1,
    zoomTo:             1.8,
    mouseWheel:         false,
    contextMenu:        false,
    scrollToZoom:       true,
    captionSmallDevice: false,
    thumbnails:         true,
    thumbnailsNav:      'centered',
    thumbnailSizes:     {
        1920: {
            width:  110,
            height: 80,
            gutter: 10
        },
        1280: {
            width:  90,
            height: 65,
            gutter: 10
        },
        680:  {
            width:  0,
            height: 0,
            gutter: 0
        }
    }
});

modulobox.on('beforeOpen.modulobox', function(gallery, index) {
    if(window.cubeRAF) {
        cancelAnimationFrame(window.cubeRAF);
        window.cubeRAF = false;
    }
});

modulobox.on('afterClose.modulobox', function(gallery, index) {
    if(typeof Event === 'function' && !window.cubeRAF) {
        window.dispatchEvent(new Event('scroll'));
    }
});

modulobox.init();